module.exports = __webpack_public_path__ + "static/logo-115dee75918a9c8f6501e39d689afaa2.png";